<template>
  <div class="pravo">
    <PravoTop Image="editProducts" Header="New Game" />

    <div class="pravo__obsah">
      <div class="pravo__newGame">
        <div class="pravo__newGame__headline">Create new game</div>
        <div class="pravo__newGame__box">
          <div class="pravo__newGame__box__full">
            <div class="pravo__newGame__box__full__tlacitka">
              <button
                class="pravo__newGame__box__full__tlacitka__vytvorit"
                @click="sendFormAndOpen()"
              >
                Create and open game
              </button>
              <button
                class="pravo__newGame__box__full__tlacitka__vytvorit"
                @click="sendForm()"
              >
                Create game
              </button>
              <button
                class="pravo__newGame__box__full__tlacitka__ulozit"
                @click="saveTemplate()"
                v-if="amIAdmin"
              >
                Save template
              </button>
              <button
                class="pravo__newGame__box__full__tlacitka__smazat"
                @click="deleteTemplate()"
                v-if="amIAdmin"
              >
                Delete template
              </button>
            </div>
          </div>
          <div class="pravo__newGame__box__full">
            <div class="pravo__newGame__box__headline">Template</div>
            <br />
            <select v-model="currentTemplate.data.id" @change="setCurrentTemplate()">
              <option value="0" disable hidden>Default template</option>
              <option
                v-for="template in getAllGameTemplates"
                :key="template.id"
                :value="template.id"
              >
                {{ template.name }}
              </option>
            </select>
          </div>
          <div class="pravo__newGame__box__full" v-if="amIAdmin">
            <div class="pravo__newGame__box__headline">Template name:</div>
            <br />
            <input
              type="text"
              placeholder="Game name"
              v-model="currentTemplate.data.name"
              class="pravo__newGame__box__gameNameInput"
            />
          </div>
          <div class="pravo__newGame__box__full" v-if="amIAdmin">
            <div class="pravo__newGame__box__headline">Template description:</div>
            <br />
            <input
              type="text"
              placeholder="Game name"
              v-model="currentTemplate.data.description"
              class="pravo__newGame__box__gameNameInput"
            />
          </div>
          <div class="pravo__newGame__box__full" style="margin-top: 50px">
            <div class="pravo__newGame__box__headline">Game name:</div>
            <br />
            <input
              type="text"
              placeholder="Game name"
              v-model="currentTemplate.data.jsonData.name"
              class="pravo__newGame__box__gameNameInput"
            />
          </div>
          <br />

          <div class="pravo__newGame__box__full__setGame">
            <br />

            <div class="pravo__newGame__box__half">
              <div class="pravo__newGame__box__headline">Rounds:</div>

              <div class="pravo__newGame__box__rounds">
                <button
                  class="pravo__newGame__box__rounds__button minus"
                  @click="maxTurnDown()"
                >
                  -
                </button>
                <input
                  type="text"
                  class="pravo__newGame__box__rounds__input"
                  v-model="currentTemplate.data.jsonData.maxTurn"
                />
                <button
                  class="pravo__newGame__box__rounds__button plus"
                  @click="maxTurnUp()"
                >
                  +
                </button>
              </div>
            </div>
            <div class="pravo__newGame__box__half">
              <div class="pravo__newGame__box__headline">Round length:</div>

              <div class="pravo__newGame__box__rounds">
                <button
                  class="pravo__newGame__box__rounds__button minus"
                  @click="currentTemplate.data.jsonData.turnLength--"
                >
                  -
                </button>
                <input
                  type="text"
                  class="pravo__newGame__box__rounds__input"
                  v-model="currentTemplate.data.jsonData.turnLength"
                />
                <button
                  class="pravo__newGame__box__rounds__button plus"
                  @click="currentTemplate.data.jsonData.turnLength++"
                >
                  +
                </button>
              </div>
              <span class="pravo__newGame__box__gray"> seconds</span>
            </div>
          </div>
          <div class="pravo__newGame__box__full__privateGame">
            Private game:
            <div class="pravo__newGame__box__radio">
              <label class="container">
                <input
                  type="checkbox"
                  :id="currentTemplate.data.jsonData.isPrivate"
                  name="isPrivate"
                  v-model="currentTemplate.data.jsonData.isPrivate"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="pravo__newGame__box__half">
            <div class="pravo__newGame__box__headline">Team budget:</div>
            <input
              type="number"
              class="pravo__newGame__box__inline budget"
              v-model="currentTemplate.data.jsonData.teamStartBudget"
            />
            <span class="pravo__newGame__box__gray"> €</span>
            <br />
            <div class="pravo__newGame__box__headline">Ad limit:</div>
            <input
              type="number"
              class="pravo__newGame__box__inline"
              v-model="currentTemplate.data.jsonData.adLimitPerTurn"
            />
          </div>
          <div class="pravo__newGame__box__full">
            <div class="pravo__newGame__box__headline">Goal</div>
            <br />
            <select v-model="currentTemplate.data.jsonData.goal">
              <option value="MONEY">Money</option>
              <option value="PRODUCTS_SOLD">Products sold</option>
              <option value="POPULAR_PRODUCT">Popular product</option>
              <option value="EARNED">Earned</option>
              <option value="PROFIT">Profit</option>
              <option value="MARKET_SHARE">Market share</option>
            </select>
          </div>

          <div class="clearfix"></div>
          <div class="pravo__newGame__box__category oddelenitlacitek" v-if="amIAdmin">
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(1)"
            >
              Demography
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(2)"
            >
              Formulas
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(3)"
            >
              Products
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(4)"
            >
              Ad types
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(5)"
            >
              Locations
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(6)"
            >
              Agents
            </button>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(7)"
            >
              Other
            </button>
          </div>
          <div class="pravo__newGame__box__category oddelenitlacitek" v-else>
            <button
              class="pravo__newGame__box__category__button"
              v-on:click="toggleDiv(7)"
            >
              Advanced settings
            </button>
          </div>
          <div v-if="display_formulas.demografie" class="pravo__newGame__section">
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Demography price 50:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.demography50Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Demography price 100:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.demography100Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Quantitative - price of my 50 products:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.quantMyProds50Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__line">
              <div class="pravo__newGame__section__lineDemo__levo">
                Quantitative - price of my 100 products:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.quantMyProds100Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Quantitative - price of all 50 products:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.quantAllProds50Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Quantitative - price of all 100 products:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.quantAllProds100Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Sold products price:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.soldProdsPrice"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Ad types - Price od my 50 ads:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.adTypesMy50Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Ad types - Price od my 100 ads:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.adTypesMy100Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Ad types - Price od all 50 ads:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.adTypesAll50Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
            <div class="pravo__newGame__section__lineDemo">
              <div class="pravo__newGame__section__lineDemo__levo">
                Ad types - Price od all 100 ads:
              </div>
              <div class="pravo__newGame__section__lineDemo__pravo">
                <input
                  type="text"
                  v-model.lazy="currentTemplate.data.jsonData.adTypesAll100Price"
                />
                <span class="pravo__newGame__box__gray"> €</span>
              </div>
            </div>
          </div>

          <div v-if="display_formulas.vzorce" class="pravo__newGame__section">
            <div class="pravo__newGame__box__headline">mathAdMindfulness:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathAdMindfulness"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathCategoryDemand:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathCategoryDemand"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathCookingAtHome:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathCookingAtHome"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathProductDemand:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathProductDemand"
              />
            </div>
            <div class="pravo__newGame__box__headline">
              mathProductPriceEvalWithSpendingWill:
            </div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="
                  currentTemplate.data.jsonData.mathProductPriceEvalWithSpendingWill
                "
              />
            </div>
            <div class="pravo__newGame__box__headline">
              mathSensitivityToPriceChanges:
            </div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathSensitivityToPriceChanges"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathImpactOfAdOnDemand:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathImpactOfAdOnDemand"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathShortTermDemand:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathShortTermDemand"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathLongTermDemandPositive:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathLongTermDemandPositive"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathLongTermDemandNegative:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathLongTermDemandNegative"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathOvercrowdMediaType:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathOvercrowdMediaType"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathNewCookingAtHome:</div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathNewCookingAtHome"
              />
            </div>
            <div class="pravo__newGame__box__headline">
              mathNewProductQualityComputation:
            </div>
            <div class="pravo__newGame__section__input">
              <input
                type="text"
                :value="currentTemplate.data.jsonData.mathNewProductQualityComputation"
              />
            </div>
            <div class="pravo__newGame__box__headline">mathOvereat:</div>
            <div class="pravo__newGame__section__input">
              <input type="text" :value="currentTemplate.data.jsonData.mathOvereat" />
            </div>
          </div>
          <div v-if="display_formulas.produkty" class="pravo__newGame__section">
            <div
              class="pravo__newGame__section__input"
              v-for="product in currentTemplate.data.jsonData.productCategories"
              :key="product.name"
            >
              <div class="pravo__newGame__section__product__headline">
                {{ product.name }}:
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Name:</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model.lazy="product.name" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Min cost:</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="product.minCost" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Max cost:</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="product.maxCost" />
                </div>
              </div>
            </div>
            <button class="pravo__newGame__box__send" @click="newProduct()">
              Add product
            </button>
          </div>
          <div v-if="display_formulas.adtypes" class="pravo__newGame__section">
            <div
              class="pravo__newGame__section__adtype"
              v-for="adtype in currentTemplate.data.jsonData.adTypes"
              :key="adtype.name"
            >
              <div class="pravo__newGame__section__adtype__headline">
                {{ adtype.name }}:
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Name</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model.lazy="adtype.name" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Visibility</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="adtype.visibility" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Hit rate</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="adtype.hitRate" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Price</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="adtype.price" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Location price step</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="adtype.locationPriceStep" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Daytime price step</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="number" v-model="adtype.dayTimePriceStep" />
                </div>
              </div>
            </div>
            <button class="pravo__newGame__box__send" @click="newAdtype()">
              Add ad type
            </button>
          </div>
          <div v-if="display_formulas.locations" class="pravo__newGame__section">
            <div
              class="pravo__newGame__section__input"
              v-for="location in currentTemplate.data.jsonData.locations"
              :key="location.name"
            >
              <div class="pravo__newGame__section__product__headline">
                {{ location.name }}:
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Name:</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model.lazy="location.name" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Tag:</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="location.tags" />
                </div>
              </div>
            </div>
            <button class="pravo__newGame__box__send" @click="newLocation()">
              Add location
            </button>
          </div>

          <div v-if="display_formulas.agents" class="pravo__newGame__section">
            <div
              class="pravo__newGame__section__input"
              v-for="agent in currentTemplate.data.jsonData.agentSettings"
              :key="agent.name"
            >
              <div class="pravo__newGame__section__product__headline">
                {{ agent.profileName }}:
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Profile name</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model.lazy="agent.profileName" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Tolerance</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.tolerance" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Tolerance penalty</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.tolerancePenalty" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Price sensitivity</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.priceSensitivity" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Probability limit</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.probabilityLimit" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Quality preference</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.qualityPreference" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Random limit</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.randomLimit" />
                </div>
              </div>
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Spending will</div>
                <div class="pravo__newGame__section__line__pravo">
                  <input type="text" v-model="agent.spendingWill" />
                </div>
              </div>
              <div class="pravo__newGame__section__subsection">
                <div class="pravo__newGame__section__product__headline">
                  Category preferences:
                </div>
                <div
                  class="pravo__newGame__section__subsection__content"
                  v-for="category in agent.categoryPreferences"
                  :key="category.categoryName"
                >
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">Category name</div>
                    <div class="pravo__newGame__section__line__pravo">
                      <input type="text" v-model="category.categoryName" />
                    </div>
                  </div>
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">
                      Value preference
                    </div>
                    <div class="pravo__newGame__section__line__pravo">
                      <input type="text" v-model="category.valuePreference" />
                    </div>
                  </div>
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">Agent count</div>
                    <div class="pravo__newGame__section__line__pravo">
                      <input type="text" v-model="category.agentCount" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="pravo__newGame__section__subsection">
                <div class="pravo__newGame__section__product__headline">
                  Media type hit rate:
                </div>
                <div
                  class="pravo__newGame__section__subsection__content"
                  v-for="adType in agent.mediaTypeHitRates"
                  :key="adType.adTypeName"
                >
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">Adtype name</div>
                    <div class="pravo__newGame__section__line__pravo">
                      <input type="text" v-model="adType.adTypeName" />
                    </div>
                  </div>
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">
                      Profile preference
                    </div>
                    <div class="pravo__newGame__section__line__pravo">
                      <input type="text" v-model="adType.profilePreference" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="pravo__newGame__section__subsection">
                <div class="pravo__newGame__section__product__headline">
                  Time preference:
                </div>
                <div
                  class="pravo__newGame__section__subsection__content"
                  v-for="time in agent.timePreferences"
                  :key="time.daytime"
                >
                  <div class="pravo__newGame__section__line">
                    <div class="pravo__newGame__section__line__levo">
                      Daytime {{ time.daytime }}
                    </div>
                  </div>
                  <div
                    class="pravo__newGame__section__subsection"
                    v-for="probable in time.probableStays"
                    :key="probable.tag"
                  >
                    <div class="pravo__newGame__section__line">
                      <div class="pravo__newGame__section__line__levo">Probability</div>
                      <div class="pravo__newGame__section__line__pravo">
                        <input type="text" v-model="probable.probability" />
                      </div>
                    </div>
                    <div class="pravo__newGame__section__line">
                      <div class="pravo__newGame__section__line__levo">Tag</div>
                      <div class="pravo__newGame__section__line__pravo">
                        <input type="text" v-model="probable.tag" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="display_formulas.other" class="pravo__newGame__section">
            <div class="pravo__newGame__section__input">
              <div class="pravo__newGame__section__line">
                <div class="pravo__newGame__section__line__levo">Game type</div>
                <div class="pravo__newGame__section__line__pravo">
                  <select v-model="currentTemplate.data.jsonData.type">
                    <option value="VANILLA">Vanilla</option>
                    <option value="DEMO">Demo</option>
                  </select>
                </div>
              </div>
              <div
                class="pravo__newGame__section__line"
                v-for="(round, index) in currentTemplate.data.jsonData.turnLengths"
                :key="index"
              >
                <div class="pravo__newGame__section__line__levo">
                  Round {{ index + 1 }} length
                </div>
                <div class="pravo__newGame__box__half">
                  <div class="pravo__newGame__box__rounds">
                    <button
                      class="pravo__newGame__box__rounds__button minus"
                      @click="turnLengthsDown(index)"
                    >
                      -
                    </button>
                    <input
                      type="text"
                      class="pravo__newGame__box__rounds__input"
                      v-model="currentTemplate.data.jsonData.turnLengths[index]"
                      @change="updateRoundTime()"
                    />
                    <button
                      class="pravo__newGame__box__rounds__button plus"
                      @click="turnLengthsUp(index)"
                    >
                      +
                    </button>
                  </div>
                  <span class="pravo__newGame__box__gray"> seconds</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PravoTop from "@/components/game/pravo/PravoTop.vue";
//import mapScenario from "@/components/gameManager/newGame/mapScenario.vue";

export default {
  name: "newGame",
  components: {
    PravoTop,
  },
  data() {
    return {
      counting: 0,
      display_formulas: {
        vzorce: false,
        demografie: false,
        produkty: false,
        adtypes: false,
        locations: false,
        agents: false,
        other: false,
      },
      agentErrors: {
        valuePreference: "",
      },
      currentTemplate: {
        data: {
          id: 0,
          name: "New template",
          description: "Template description",
          jsonData: {
            maxTurn: 5,
            turnLength: 90000,
            turnLengths: [900, 900, 900, 900, 900],
            name: "New Easy game",
            teamStartBudget: 5000,
            adLimitPerTurn: 150,
            isPrivate: true,
            demography50Price: 60,
            demography100Price: 110,
            quantMyProds50Price: 80,
            quantMyProds100Price: 150,
            quantAllProds50Price: 140,
            quantAllProds100Price: 250,
            qualAllProdsPrice: 40,
            soldProdsPrice: 80,
            adTypesMy50Price: 80,
            adTypesMy100Price: 150,
            adTypesAll50Price: 140,
            adTypesAll100Price: 250,
            newDemand: true,
            goal: "MONEY",
            type: "VANILLA",
            daysPerTurn: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
            partsPerDay: ["0-8h", "8-16h", "16-24h"],
            mathAdMindfulness: "randomizer<=adVisibility*agentMediaTypeHitRate",
            mathCategoryDemand:
              "currCatDemand + (currCatDemand * mathImpactOfAdOnDemand * categoryPreference) * 0.025",
            mathCookingAtHome:
              "preferredQuality * (income/daysPerTurnCount) * spendingWill",
            mathProductDemand:
              "currProDemand + (1/seenPerDaytimeCount) * (currProDemand * mathProductPriceEvalWithSpendingWill * mathProductQualityComputation * mathImpactOfAdOnDemand * categoryPreference) * (mathSensitivityToPriceChanges + (1 - agentSensitivityToPriceChange))",
            mathProductPriceEvalWithSpendingWill: "(moneyBase * spendingWill)/price",
            mathProductQualityComputation: "1 - abs(quality - preferredQuality)",
            mathSensitivityToPriceChanges:
              "((originalRelativePrice/newRelativePrice) * agentSensitivityToPriceChange)  + (1 - agentSensitivityToPriceChange)",
            mathImpactOfAdOnDemand: "mediaTypeIntensity * agentMediaTypeHitRate",
            mathShortTermDemand:
              "currProShortTermDemand + (overcrowdMediaType * 6 * mathProductPriceEvalWithSpendingWill * mathImpactOfAdOnDemand * categoryPreference * agentSensitivityToPriceChange * agentSensitivityToPriceChange)",
            mathLongTermDemandPositive:
              "currProDemand + (2 * productQualityComputation * mathProductPriceEvalWithSpendingWill * agentSensitivityToPriceChange * agentSensitivityToPriceChange * overeat * categoryPreference)",
            mathLongTermDemandNegative:
              "currProDemand + ((25 * productQualityComputation) / (mathProductPriceEvalWithSpendingWill * categoryPreference * agentSensitivityToPriceChange * agentSensitivityToPriceChange))",
            mathOvercrowdMediaType:
              "(1 / mediaTypeSeenThisDay) * (1 / mediaTypeSeenThisDay)",
            mathNewCookingAtHome: "(income * preferredQuality * 0.5) / daysPerTurnCount",
            mathNewProductQualityComputation: "1 - (2 * (preferredQuality - quality))",
            mathOvereat: "20 / (1 + allTimePurchaseThisProduct)",
            productCategories: [
              {
                maxCost: 10,
                minCost: 2,
                name: "Czech cuisine",
              },
            ],
            adTypes: [
              {
                visibility: 0.4,
                hitRate: 0.55,
                name: "citylight",
                price: 30,
                locationPriceStep: 30,
                dayTimePriceStep: 30,
              },
              {
                visibility: 0.6,
                hitRate: 0.35,
                name: "billboard",
                price: 40,
                locationPriceStep: 40,
                dayTimePriceStep: 40,
              },
              {
                visibility: 0.35,
                hitRate: 0.5,
                name: "print-on-bus",
                price: 14,
                locationPriceStep: 14,
                dayTimePriceStep: 14,
              },
              {
                visibility: 0.2,
                hitRate: 0.25,
                name: "flyer distribution",
                price: 8,
                locationPriceStep: 8,
                dayTimePriceStep: 8,
              },
              {
                visibility: 0.4,
                hitRate: 0.55,
                name: "promo stand small",
                price: 30,
                locationPriceStep: 30,
                dayTimePriceStep: 30,
              },
              {
                visibility: 0.35,
                hitRate: 0.6,
                name: "hostess on the street",
                price: 24,
                locationPriceStep: 24,
                dayTimePriceStep: 24,
              },
              {
                visibility: 0.6,
                hitRate: 0.35,
                name: "radio spot",
                price: 25,
                locationPriceStep: 25,
                dayTimePriceStep: 25,
              },
              {
                visibility: 0.55,
                hitRate: 0.55,
                name: "promo stand big",
                price: 25,
                locationPriceStep: 25,
                dayTimePriceStep: 25,
              },
            ],
            locations: [
              {
                name: "City center",
                tags: ["center"],
              },
              {
                name: "Outskirts",
                tags: ["outskirts"],
              },
              {
                name: "Built-up",
                tags: ["built-up"],
              },
            ],
            agentSettings: [
              {
                createNewProfile: false,
                profileName: "Rich",
                tolerance: 0.2,
                tolerancePenalty: 0.25,
                income: 300,
                priceSensitivity: 0.2,
                probabilityLimit: 30,
                qualityPreference: 0.8,
                randomLimit: 0.1,
                spendingWill: 0.35,
                categoryPreferences: [
                  {
                    categoryName: "Czech cuisine",
                    valuePreference: 1,
                    agentCount: 20,
                  },
                ],
                mediaTypeHitRates: [
                  {
                    adTypeName: "citylight",
                    profilePreference: 0.5,
                  },
                  {
                    adTypeName: "billboard",
                    profilePreference: 1,
                  },
                  {
                    adTypeName: "print-on-bus",
                    profilePreference: 0.5,
                  },
                  {
                    adTypeName: "flyer distribution",
                    profilePreference: 0.4,
                  },
                  {
                    adTypeName: "promo stand small",
                    profilePreference: 0.7,
                  },
                  {
                    adTypeName: "hostess on the street",
                    profilePreference: 0.9,
                  },
                  {
                    adTypeName: "radio spot",
                    profilePreference: 0.9,
                  },
                  {
                    adTypeName: "promo stand big",
                    profilePreference: 0.85,
                  },
                ],
                timePreferences: [
                  {
                    daytime: 1,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 2,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 3,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 4,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 5,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 6,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 7,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 8,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 9,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 10,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 11,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 12,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 13,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 14,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 15,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 16,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 17,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 18,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 19,
                    probableStays: [
                      {
                        probability: 0.6,
                        tag: "center",
                      },
                      {
                        probability: 0.3,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 20,
                    probableStays: [
                      {
                        probability: 0.7,
                        tag: "center",
                      },
                      {
                        probability: 0.2,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                  {
                    daytime: 21,
                    probableStays: [
                      {
                        probability: 0.25,
                        tag: "center",
                      },
                      {
                        probability: 0.65,
                        tag: "outskirts",
                      },
                      {
                        probability: 0.1,
                        tag: "built-up",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      },
      choosenTemplate: 0,
    };
  },
  computed: {
    ...mapGetters(["getAllGameTemplates", "amIAdmin"]),
  },
  async mounted() {
    await this.$store.dispatch("getAllTemplates");
    this.currentTemplate.data.id = this.getAllGameTemplates[0].id;
    this.setCurrentTemplate();
    this.setUniqueName();
  },
  methods: {
    /*refreshCode() {
            if(this.uniqueCode == '254ebhd45d')
              this.uniqueCode = 'e3g5b2j5k'
            else
              this.uniqueCode = '254ebhd45d'
          },*/
    toggleDiv(source) {
      if (source == 1) {
        this.closeAll("demografie");
        this.display_formulas.demografie = !this.display_formulas.demografie;
      }

      if (source == 2) {
        this.closeAll("vzorce");
        this.display_formulas.vzorce = !this.display_formulas.vzorce;
      }

      if (source == 3) {
        this.closeAll("produkty");
        this.display_formulas.produkty = !this.display_formulas.produkty;
      }

      if (source == 4) {
        this.closeAll("adtypes");
        this.display_formulas.adtypes = !this.display_formulas.adtypes;
      }

      if (source == 5) {
        this.closeAll("locations");
        this.display_formulas.locations = !this.display_formulas.locations;
      }

      if (source == 6) {
        this.closeAll("agents");
        this.display_formulas.agents = !this.display_formulas.agents;
      }

      if (source == 7) {
        this.closeAll("other");
        this.display_formulas.other = !this.display_formulas.other;
        if (
          typeof this.currentTemplate.data.jsonData.turnLengths === "undefined" ||
          this.currentTemplate.data.jsonData.turnLengths === null
        ) {
          console.log("Neexistje");
          var turnLengths = [];
          for (var i = 0; i < this.currentTemplate.data.jsonData.maxTurn; i++) {
            turnLengths.push(this.currentTemplate.data.jsonData.turnLength);
          }
          this.currentTemplate.data.jsonData.turnLengths = turnLengths;
        } else {
          console.log("existuje", this.currentTemplate.data.jsonData.turnLengths);
        }
      }
    },
    sendForm() {
      this.checkDaytimes();
      this.checkMediaTypes();
      this.checkCategories();
      console.log(this.currentTemplate.data);
      try {
        if (this.currentTemplate.data.jsonData.turnLength <= 1800) {
          this.$store.dispatch("createGame", this.currentTemplate.data);
          this.setUniqueName();
          this.$toast.success("Game has been created");
          this.$router.push({ name: "GameManager.allGames" });
        } else {
          this.$toast.error("Round length must be less then or equal to 1800");
        }
      } catch (e) {
        this.$toast.error("Error.");
      }
    },
    async sendFormAndOpen() {
      var finish = await this.sendFormOpen();
      var redirect = this.$router.push({
        name: this.$store.getters.joinedGame.startedTime
          ? "GameManager.game.overview"
          : "GameManager.game.lobby",
      });
      console.log("Přesměrování");
      console.log(redirect);
    },
    async sendFormOpen() {
      this.checkDaytimes();
      this.checkMediaTypes();
      this.checkCategories();
      try {
        if (this.currentTemplate.data.jsonData.turnLength <= 1800) {
          await this.$store.dispatch("createGameAndActivate", this.currentTemplate.data);
          this.setUniqueName();
          this.$toast.success("Game has been created");
        } else {
          this.$toast.error("Round length must be less then or equal to 1800");
        }
      } catch (e) {
        this.$toast.error("Error.");
      }
    },
    setUniqueName() {
      if (typeof this.currentTemplate.data.jsonData.name === "undefined") {
        this.currentTemplate.data.jsonData.name =
          this.currentTemplate.data.name + this.rndStr(8);
      } else {
        console.log(this.currentTemplate.data.jsonData.name);
        if (this.currentTemplate.data.jsonData.name.indexOf("#") !== -1) {
          const arr = this.currentTemplate.data.jsonData.name.split(" #");
          this.currentTemplate.data.jsonData.name = arr[0] + this.rndStr(8);
        } else {
          this.currentTemplate.data.jsonData.name =
            this.currentTemplate.data.jsonData.name + this.rndStr(8);
        }
      }
    },
    checkDaytimes() {
      var complete = true;
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.timePreferences.forEach((entryPreference) => {
          entryPreference.probableStays.forEach((entryStays) => {
            if (entryStays.tag == "") {
              complete = false;
            }
          });
        });
      });
      if (!complete) {
        this.$toast.error(this.$t("Agenti nemají vyplněné všechny dny"));
      }
    },
    checkMediaTypes() {
      var complete = true;
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.mediaTypeHitRates.forEach((entryMedia) => {
          if (entryMedia.adTypeName == "") {
            complete = false;
          }
        });
      });
      if (!complete) {
        this.$toast.error(this.$t("Agenti nemají vyplněné mediatypy"));
      }
    },
    checkCategories() {
      var complete = true;
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.categoryPreferences.forEach((entryCategory) => {
          if (entryCategory.categoryName == "") {
            complete = false;
          }
        });
      });
      if (!complete) {
        this.$toast.error(this.$t("Agenti nemají vyplněné preference kategorií"));
      }
    },
    async saveTemplate() {
      try {
        await this.$store.dispatch("saveTemplate", this.currentTemplate);
        await this.$store.dispatch("getAllTemplates");
        this.$toast.success("Template has been saved");
      } catch (e) {
        this.$toast.error("Error. Template not saved");
      }
    },
    async deleteTemplate() {
      try {
        await this.$store.dispatch("deleteTemplate", this.currentTemplate);
        await this.$store.dispatch("getAllTemplates");
        this.$toast.success("Template has been deleted");
      } catch (e) {
        this.$toast.error("Error. Template not deleted");
      }
    },
    newProduct() {
      const numProduct = this.currentTemplate.data.jsonData.productCategories.length;
      const nameCategory = "New product category " + numProduct;
      this.currentTemplate.data.jsonData.productCategories.push({
        maxCost: 10,
        minCost: 2,
        name: nameCategory,
      });
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.categoryPreferences.push({
          categoryName: "",
          valuePreference: 1,
          agentCount: 20,
        });
      });
    },
    newLocation() {
      const numLocation = this.currentTemplate.data.jsonData.locations.length;
      const nameLocation = "New location " + numLocation;
      this.currentTemplate.data.jsonData.locations.push({
        name: nameLocation,
      });
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.timePreferences.forEach((entry2) => {
          entry2.probableStays.push({
            tag: "",
            probability: 0.5,
          });
        });
      });
    },
    newAdtype() {
      const numAdtypes = this.currentTemplate.data.jsonData.adTypes.length;
      const nameAdtype = "New adtype " + numAdtypes;
      this.currentTemplate.data.jsonData.adTypes.push({
        visibility: 0.1,
        hitRate: 0.1,
        name: nameAdtype,
        price: 100,
        locationPriceStep: 30,
        dayTimePriceStep: 30,
      });
      this.currentTemplate.data.jsonData.agentSettings.forEach((entry) => {
        entry.mediaTypeHitRates.push({
          adTypeName: "",
          profilePreference: 0.5,
        });
      });
    },
    checkValuePreferences() {
      var sum = 0;
      this.currentTemplate.data.jsonData.agentSettings.categoryPreferences.forEach(
        (entry) => {
          sum += entry.valuePreference;
        }
      );
      /*for (var key in this.currentTemplate.data.jsonData.agentSettings.categoryPreferences) {
                sum += key.
            }*/
      if (sum != 1) {
        this.agentErrors.valuePreference = "Nesedí součet";
      }
    },
    async setCurrentTemplate() {
      if (this.currentTemplate.data.id != 0) {
        this.currentTemplate = await this.$store.dispatch(
          "getTemplateById",
          this.currentTemplate.data.id
        );
        this.currentTemplate.data.jsonData.isPrivate = true;
        this.setUniqueName();
      }
    },
    rndStr(len) {
      let text = " #";
      let chars = "abcdefghijklmnopqrstuvwxyz1234567890";

      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },
    getCurrentTemplate() {
      return this.currentTemplate.data;
    },
    closeAll(source) {
      for (var key in this.display_formulas) {
        if (source != key) {
          this.display_formulas[key] = false;
        }
      }
    },
    maxTurnUp() {
      this.currentTemplate.data.jsonData.maxTurn++;
      this.currentTemplate.data.jsonData.turnLengths.push(
        this.currentTemplate.data.jsonData.turnLength
      );
    },
    maxTurnDown() {
      this.currentTemplate.data.jsonData.maxTurn--;
      this.currentTemplate.data.jsonData.turnLengths.splice(
        this.currentTemplate.data.jsonData.turnLengths.indexOf(event),
        1
      );
    },
    turnLengthsDown(index) {
      var val = this.currentTemplate.data.jsonData.turnLengths[index];
      val--;

      this.$set(this.currentTemplate.data.jsonData.turnLengths, index, val);
      this.currentTemplate.data.jsonData.maxTurn =
        this.currentTemplate.data.jsonData.maxTurn + 0;
      this.maxTurnUp();
      this.maxTurnDown();
      // this.currentTemplate.data.turnLengths.$set(index, val)
    },
    turnLengthsUp(index) {
      var val = this.currentTemplate.data.jsonData.turnLengths[index];
      val++;
      this.$set(this.currentTemplate.data.jsonData.turnLengths, index, val);
      console.log(this.currentTemplate.data.jsonData.turnLengths[index]);
      this.maxTurnUp();
      this.maxTurnDown();
      //this.currentTemplate.data.turnLengths.$set(index, val)
    },
    updateRoundTime() {
      this.maxTurnUp();
      this.maxTurnDown();
    },
  },
};
</script>
